import { IApiBaseProps } from '@common/api.models';
import { envConfigs } from '@config/envConfigs';
import { IPagedResultsV1 } from '@gcl/react-core';
import { ETransmittalType } from '@transmittal/transmittal.constants';
import { apiServerGet } from '@common/axios.services';
import { ITransmittalPurpose } from './transmittalPurpose.models';

export const apiRoutes = {
  getTransmittalPurposeOptions: '/TransmittalPurposes/Options/ForTransmittal',
  getAllTransmittalPurposeOptions: '/TransmittalPurposes/Options',
};

export interface IGetTransmittalPurposeOptionsAsyncProps extends IApiBaseProps {
  transmittalId?: number;
  transmittalType?: ETransmittalType;
  masterScheduleId?: number;
}
export interface IGetAllTransmittalPurposeOptionsAsyncProps extends IApiBaseProps {
  transmittalType?: ETransmittalType;
  masterScheduleId?: number;
}

export const getTransmittalPurposeOptionsAsync = async (
  props?: IGetTransmittalPurposeOptionsAsyncProps,
): Promise<IPagedResultsV1<ITransmittalPurpose>> => {
  const result = await apiServerGet<IPagedResultsV1<ITransmittalPurpose>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.getTransmittalPurposeOptions}`,
    {
      params: {
        ...props,
      },
    },
  );
  return result.data;
};

export const getAllTransmittalPurposeOptionsAsync = async (
  props?: IGetAllTransmittalPurposeOptionsAsyncProps,
): Promise<IPagedResultsV1<ITransmittalPurpose>> => {
  const result = await apiServerGet<IPagedResultsV1<ITransmittalPurpose>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.getAllTransmittalPurposeOptions}`,
    {
      params: {
        ...props,
      },
    },
  );
  return result.data;
};
